import { useState } from "react";

interface CarouselItem {
  image: string;
  subtitle: string;
  description?: string;
}

interface CarouselProps {
  items: CarouselItem[];
  className?: string;
}

const Carousel: React.FC<CarouselProps> = ({ items, className = "" }) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="mt-8 bg-white rounded-3xl">
      <div
        className={`w-full container lg:mx-auto ${className}`}
      >
        {/* Tabs Navigation */}
        <div className="flex flex-row overflow-x-auto md:flex-row md:overflow-visible md:justify-center md:space-x-16 mb-4 md:mb-10 px-6 py-2 md:py-5 scrollbar-hide">
          {items.map((item, index) => (
            <button
              key={index}
              onClick={() => setActiveTab(index)}
              className={`group flex flex-col items-center transition-colors duration-300 flex-shrink-0 px-4 mx-2 ${
                activeTab === index
                  ? "text-primary-600 font-semibold"
                  : "text-gray-500 hover:text-gray-700"
              }`}
            >
              <span className="text-base md:text-lg tracking-wide whitespace-nowrap mb-3">
                {item.subtitle}
              </span>
              <div
                className={`h-0.5 transition-colors duration-200 ${
                  activeTab === index
                    ? "bg-primary-600 w-full"
                    : "bg-transparent md:bg-gray-200 w-full md:group-hover:bg-gray-300"
                }`}
              />
            </button>
          ))}
        </div>

        {/* Image Container */}
        <div className="relative w-full bg-white overflow-hidden" style={{ aspectRatio: '16/9' }}>
          {items.map((item, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-500 ease-in-out ${
                activeTab === index ? "opacity-100" : "opacity-0"
              }`}
            >
              <img
                src={item.image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-contain"
              />
            </div>
          ))}
        </div>

        {/* Description Text */}
        <div className="mt-6 sm:mt-8">
          {items.map((item, index) => (
            <div
              key={index}
              className={`transition-all duration-500 ease-in-out ${
                activeTab === index
                  ? "opacity-100 transform translate-y-0"
                  : "opacity-0 transform translate-y-4 pointer-events-none hidden"
              }`}
            >
              {item.description && (
                <div className="text-center px-3 sm:px-6">
                  <p className="text-gray-600 text-sm sm:text-base md:text-lg max-w-3xl mx-auto leading-relaxed tracking-wide">
                    {item.description}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Carousel;
